import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { PasswordGenerator } from "../components/PasswordGenerator";
import { PwBreadcrumb } from "../components/PwBreadcrumb";
import { PwExplainer } from "../components/PwExplainer";

export function PasswordGeneratorPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <PwBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.pw_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.pw_intro()}
          </p>
        </header>

        <PasswordGenerator />

        <PwExplainer
          howTo={m.pw_howto()}
          faqs={[
            { q: m.pw_faq1_q(), a: m.pw_faq1_a() },
            { q: m.pw_faq2_q(), a: m.pw_faq2_a() },
            { q: m.pw_faq3_q(), a: m.pw_faq3_a() },
            { q: m.pw_faq4_q(), a: m.pw_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
